/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Row, Col, Button } from "antd";
import { Link, useHistory } from "react-router-dom";
import { accountBaseUrl } from "../../helpers/account";
import * as actions from "./actions";
import * as bookingActions from "modules/Booking/actions";
import ExistingPatients from "./Patient/ExistingPatients";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import Guest from "./Guest";
import {
	getOtpKey,
	getOtpVerified,
	getPatients,
	getOtpVerificationRequestState,
} from "./reducers";
import {
	getCurrentPatient,
	getAvailabilityRequests,
} from "modules/Booking/reducers";
import { getCurrentLocation } from "../Location/reducers";
import NewPatientForm from "./Patient/NewPatient";
import { ArrowLeftOutlined } from "@ant-design/icons";

import ContentContainer from "../../components/ContentContainer";
import { trackEvent, trackFBStandardEvent } from "utils/analytics";
import usePageView from "../../hooks/usePageView";

function App({
	match,
	generateOtpRequest,
	otpKey,
	verifyOtpRequest,
	isOtpverified,
	patients,
	setCurrentPatient,
	currentPatient,
	otpVerificationRequestState,
	deleteRequestsUnlessValidSlot,
	currentPractice,
	availabilityRequests,
	cancelReservationRequest,
	clearOtpKey,
}) {
	const { params } = match;
	const practiceId = params.locationId;
	const account = params.account;
	const history = useHistory();
  const { executeRecaptcha } = useGoogleReCaptcha();

	const [otpMethod, setOtpMethod] = useState("sms");

	// Track page view with step info
	usePageView("Verification", 4, "verification", 80);

	const handleResubmit = async (values) => {
    const token = await executeRecaptcha('resend_otp');
    generateOtpRequest(account, token, values);
  };

	const manageOtpMethod = async (values) => {
    const { mobileRegionCode, mobileRegionShort, otp } = values;
    const mobilePhone = otpMethod === "sms" ? values.mobilePhone : null;
    const email = otpMethod === "email" ? values.email : null;

    if (otpKey) {
      verifyOtpRequest(account, practiceId, {
        mobilePhone, mobileRegionCode, mobileRegionShort,
        email, otpKey, otpMethod, otp,
      });
      trackEvent("otp_verified", { method: otpMethod });
      trackFBStandardEvent("Lead");
    } else {
      const token = await executeRecaptcha('request_otp');
      generateOtpRequest(account, token, {
        mobilePhone, mobileRegionCode, mobileRegionShort,
        email, otpMethod,
      });
      trackEvent("otp_requested", { method: otpMethod });
    }
  };

	useEffect(() => {
		deleteRequestsUnlessValidSlot();
	}, []);

	const handleGoBack = React.useCallback(() => {
		if (isOtpverified) {
			cancelReservationRequest(currentPractice.id, availabilityRequests);
			history.go(-history.length + 1);
		} else {
			cancelReservationRequest(currentPractice.id, availabilityRequests);
			history.goBack();
		}
	}, [isOtpverified]);

	return (
		<ContentContainer
			themeColor={currentPractice?.themeColor}
			showNext={false}
			backButton={
				<Button
					type="text"
					shape="circle"
					onClick={() => {
						handleGoBack();
					}}
					icon={<ArrowLeftOutlined />}
				/>
			}
			step={4}
			pageTitle="Verification"
			stepPercentage="80"
		>
			<Row gutter={[12, 12]} justify="space-around">
				{!isOtpverified && (
					<Col span={24}>
						<Guest
							backButton={
								<Button>
									{" "}
									<Link
										style={{ color: "inherit" }}
										to={`${accountBaseUrl}/locations/${practiceId}/reasons`}
										onClick={() =>
											cancelReservationRequest(
												currentPractice.id,
												availabilityRequests,
											)
										}
									>
										Back
									</Link>
								</Button>
							}
							onSubmit={manageOtpMethod}
							handleResubmit={handleResubmit}
							codeVerificationMethod={otpMethod}
							setCodeVerificationMethod={setOtpMethod}
							clearOtpKey={clearOtpKey}
						/>
					</Col>
				)}

				{isOtpverified && patients && patients.length > 0 && (
					<Col span={24}>
						<ExistingPatients
							practiceId={practiceId}
							account={account}
							patients={patients}
							setCurrentPatient={setCurrentPatient}
							currentPatient={currentPatient}
						/>
					</Col>
				)}

				{isOtpverified &&
					patients &&
					patients.length <= 0 &&
					!otpVerificationRequestState && (
						<Col flex="650px">
							<NewPatientForm practiceId={practiceId} account={account} />
						</Col>
					)}
			</Row>
		</ContentContainer>
	);
}

const mapStateToProps = (state) => ({
	otpKey: getOtpKey(state.session),
	isOtpverified: getOtpVerified(state.session),
	patients: getPatients(state.session),
	currentPatient: getCurrentPatient(state.booking),
	otpVerificationRequestState: getOtpVerificationRequestState(state.session),
	currentPractice: getCurrentLocation(state.locations),
	availabilityRequests: getAvailabilityRequests(state.booking),
});

export default connect(mapStateToProps, {
	...actions,
	...bookingActions,
})(App);
